import { Waveform } from "@phosphor-icons/react";

// Subtle "Narrated by Lottie" badge shown on every narrated walkthrough.
export function NarratedByLottie({ dark = false, className = "" }) {
  return (
    <span
      data-testid="narrated-by-lottie"
      title="Every walkthrough is narrated in Lottie's own voice"
      className={`inline-flex items-center gap-1.5 text-[0.68rem] font-semibold px-2.5 py-1 rounded-full ${className}`}
      style={
        dark
          ? { background: "rgba(255,255,255,0.08)", color: "rgba(255,255,255,0.78)" }
          : { background: "rgba(242,111,33,0.09)", color: "#C2410C" }
      }
    >
      <Waveform size={13} weight="fill" style={{ color: "#F37A24" }} />
      Narrated by Lottie
    </span>
  );
}
